<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">意见反馈</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div>
                <div class="minContent">
                    <div class="phone">
                        <span>手机号</span>
                        <input type="tel" maxlength="11" placeholder="请输入手机号码">    
                    </div>
                    <textarea class="txt" placeholder="请留下您的宝贵意见和建议" cols="30" rows="10" maxlength="100" ></textarea>
                </div>
                <div class="button">
                    <button>提  交</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Navbar, TabItem,Switch,Actionsheet } from 'mint-ui';
export default {
  data() {
    return {  
        
    };
  },
  computed: {},
  components: {},
  methods: {
      //提价反馈
        save(){
            $.post(setActivityPhotos+"&sid="+sid+"&mode="+this.mode+"&sign="+this.sign,{
                upFile:this.upFile
            }).then((res)=>{
                console.log(res)
            })
            .catch((error)=>{
                console.log(sid,this.mode,this.sign)
                console.log(error)
            })
        } 
  },
  mounted(){},           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.minContent{
    width: 100%;
    height: 4.76rem;
    background-color: #fff;
    text-align: center;
    margin-top: 0.2rem;
    position: absolute;
}
.phone{
    width: 100%;
    height: 1rem;
    margin-top: 0.39rem;
    font-size: 0.42rem;
}
.phone input{
    font-size: 0.37rem;
    width: 5.45rem;
    height: 0.79rem;
    margin-left: 0.66rem;
    border: 0.03rem solid rgba(187, 187, 187, 1);
}
.txt{
    width: 7.37rem;
    height: 2.63rem;
    font-size: 0.37rem;
    font-family: 'Microsoft Yahei';
    margin-top: 0.26rem;
    border: 0.03rem solid rgba(187, 187, 187, 1);
}
.button{
    position: relative;
    top: 7.03rem;
    text-align: center;
}
.button button{
    width: 6.71rem;
    height: 1.05rem;
    border-radius: 0.16rem;
    background-color: rgba(41, 158, 173, 1);
    text-align: center;
    font-size: 0.42rem;
    color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/components/mine/feedback.vue